// import React from "react";

import { Auth } from 'aws-amplify'
// import { useEffect } from 'react'
import AwsConfig from '../../Config/AwsConfig'
import CreatePersonService from '../../Services/Mutations/CreatePersonService'
import { truevalueedit } from '../Movie/truevalueedit'

//
export default function SubmitCreatePerson(submitvalues, sendInputCreatePerson, sendInputObject) {
  let loggedInUserHandle = ''
  const loggedInUserEmail = Auth.user.attributes ? Auth.user.attributes.email : ''
  if (loggedInUserEmail) {
    const emailParams = loggedInUserEmail.split('@')
    loggedInUserHandle = '@' + emailParams[0]
  }

  const input = {
    // PK: submitvalues.rendeedPersondata.PK,
    // SK: submitvalues.rendeedPersondata.SK,
    personType: submitvalues.personType,
    moderatorID: Auth.user.username,
    moderatorHandle: loggedInUserHandle,
  }
  console.log(input, 'submit input')
  const dateOfBirth = editvalue => {
    const tempValue = editvalue.split('-')
    const tempeoryValue = tempValue[0] + tempValue[1] + tempValue[2]
    return tempeoryValue
  }

  const dateOfBirthdate = editvalue => {
    const tempValue = editvalue.split('-')
    const tempeoryValue = tempValue[1] + tempValue[2]
    return tempeoryValue
  }

  const dateOfBirthyear = editvalue => {
    const tempValue = editvalue.split('-')
    const tempeoryValue = tempValue[0]
    return tempeoryValue
  }

  // console.log(submitvalues.personName, 'submitvalues.personName')
  truevalueedit([true, submitvalues.personName], input, 'name_En')
  truevalueedit([true, submitvalues.personNamete], input, 'name_Te')
  truevalueedit([true, submitvalues.shortBio], input, 'about_En')
  truevalueedit([true, submitvalues.shortBiote], input, 'about_Te')
  truevalueedit([true, submitvalues.wikipediaURL], input, 'personWikiURL')
  // truevalueedit([true, submitvalues.personNationality], input, 'nationality')
  // truevalueedit([true, submitvalues.personDied], input, 'died')
  // truevalueedit([true, submitvalues.PersonCurrentlyActive], input, 'currentlyActive')
  // const regex = /\([A-Za-z0-9]+\)\*/i
  // if (submitvalues.spouse_En.length > 0) {
  //   truevalueedit([true, submitvalues.spouse_En.toString()], input, 'spouse_En')
  //   truevalueedit([true, submitvalues.spouse_En], input, 'spouse_EnV2')
  //   const truetranlatedspouse = submitvalues.spouse_Te.some(e => regex.test(e) === true)
  //   truevalueedit([!truetranlatedspouse, submitvalues.spouse_Te.toString()], input, 'spouse_Te')
  //   truevalueedit([!truetranlatedspouse, submitvalues.spouse_Te], input, 'spouse_TeV2')
  // }

  // truevalueedit([true, submitvalues.Parents_En.toString()], input, 'parents_En')
  // const truetranslatedparents = submitvalues.Parents_Te
  //   ? submitvalues.Parents_Te.some(e => regex.test(e) === true)
  //   : false
  // truevalueedit([!truetranslatedparents, submitvalues.Parents_Te.toString()], input, 'parents_Te')
  // truevalueedit([true, submitvalues.Relatives_En.toString()], input, 'relatives_En')
  // const truetranslatedrelatives = submitvalues.Relatives_Te.some(e => regex.test(e) === true)
  // truevalueedit(
  //   [!truetranslatedrelatives, submitvalues.Relatives_Te.toString()],
  //   input,
  //   'relatives_Te',
  // )
  // truevalueedit([true, submitvalues.Children_En.toString()], input, 'children_En')
  // const truetranslatedchildren = submitvalues.Children_Te.some(e => regex.test(e) === true)
  // truevalueedit(
  //   [!truetranslatedchildren, submitvalues.Children_Te.toString()],
  //   input,
  //   'children_Te',
  // )
  // truevalueedit([true, submitvalues.AwardWins_En.toString()], input, 'awards_En')
  // const truetranslatedawards = submitvalues.AwardWins_Te.some(e => regex.test(e) === true)
  // truevalueedit([!truetranslatedawards, submitvalues.AwardWins_Te.toString()], input, 'awards_Te')
  truevalueedit([true, submitvalues.Almamater_En.toString()], input, 'almamater_En')
  // truevalueedit([true, submitvalues.popularPerson], input, 'popularPerson')
  // truevalueedit([true, submitvalues.GOAT], input, 'GOAT')
  truevalueedit([true, submitvalues.popularyKnownAs_En], input, 'popularyKnownAs_En')
  truevalueedit([true, submitvalues.popularyKnownAs_Te], input, 'popularyKnownAs_Te')
  // const truetranslatedalmamater = submitvalues.Almamater_Te
  //   ? submitvalues.Almamater_Te.some(e => regex.test(e) === true)
  //   : false
  truevalueedit(
    [true, submitvalues.Almamater_Te.toString()],
    input,
    'almamater_Te',
  )
  // truevalueedit([true, submitvalues.PoliticalParty_En.toString()], input, 'politicalParty_En')
  // const truetranslatedpolitical = submitvalues.PoliticalParty_Te.some(e => regex.test(e) === true)
  // truevalueedit(
  //   [!truetranslatedpolitical, submitvalues.PoliticalParty_Te.toString()],
  //   input,
  //   'politicalParty_Te',
  // )
  // truevalueedit([true, submitvalues.genRe.toString()], input, 'genres_En')
  // truevalueedit([true, submitvalues.genReTelugu.toString()], input, 'genres_Te')
  // truevalueedit([submitvalues.valueChanged.Roles_En, submitvalues.Roles_En], input, 'Roles')
  // if (submitvalues.occupation.length > 0) {
  //   const occupation = submitvalues.occupation.map(e => e.label)
  //   const occupationte = submitvalues.occupationte.map(e => e.value)
  //   truevalueedit([true, occupation], input, 'occupation_EnV2')
  //   truevalueedit([true, occupationte], input, 'occupation_TeV2')
  //   truevalueedit([true, occupation.toString()], input, 'occupation_En')
  //   truevalueedit([true, occupationte.toString()], input, 'occupation_Te')
  // }

  // truevalueedit([true, submitvalues.internalComments], input, 'internalComments')

  truevalueedit([true, submitvalues.PlaceofBirthen], input, 'placeOfBirth_En')
  truevalueedit([true, submitvalues.PlaceofBirthte], input, 'placeOfBirth_Te')
  // truevalueedit([submitvalues.valueChanged.Roles_En, submitvalues.Roles_En], input, 'movieRole')
  // truevalueedit([submitvalues.valueChanged.Roles_En, submitvalues.Roles_En], input, 'movieRole')
  const cdnurl = AwsConfig.movieCdnUrl
  if (submitvalues.personPoster && submitvalues.personPoster.includes(cdnurl)) {
    const posterUrl = submitvalues.personPoster.replace(cdnurl, '')
    truevalueedit([true, posterUrl], input, 'posterURL')
  }

  // GalleryVideos(submitvalues, input)
  // GalleryImages(submitvalues, input)
  // if (submitvalues.imageUpdatedTime) {
  //   truevalueedit(
  //     [submitvalues.valueChanged.GalleryImages, submitvalues.imageUpdatedTime],
  //     input,
  //     'imageUpdatedTime',
  //   )
  // }

  // console.log(
  //   input,
  //   submitvalues.valueChanged.GalleryImages,
  //   submitvalues.imageUpdatedTime,
  //   'inputt=============',
  // )
  if (submitvalues.dateOfBirth !== '') {
    truevalueedit(
      [true, submitvalues.dateOfBirth ? dateOfBirthdate(submitvalues.dateOfBirth) : ''],
      input,
      'birthdayMonthAndDate',
    )
    truevalueedit(
      [true, submitvalues.dateOfBirth ? dateOfBirthyear(submitvalues.dateOfBirth) : ''],
      input,
      'birthYear',
    )
    truevalueedit(
      [true, submitvalues.dateOfBirth ? dateOfBirth(submitvalues.dateOfBirth) : ''],
      input,
      'dateOfBirth',
    )
  }

  // truevalueedit(
  //   [true, submitvalues.yousayPersonReviewURL_Te ? submitvalues.yousayPersonReviewURL_Te : ''],
  //   input,
  //   'yousayPersonReviewURL_Te',
  // )
  // truevalueedit(
  //   [true, submitvalues.yousayPersonReviewURL_En ? submitvalues.yousayPersonReviewURL_En : ''],
  //   input,
  //   'yousayPersonReviewURL_En',
  // )
  // truevalueedit(
  //   [
  //     true,
  //     submitvalues.personArticleReviewTitle_En ? submitvalues.personArticleReviewTitle_En : '',
  //   ],
  //   input,
  //   'personArticleReviewTitle_En',
  // )
  // truevalueedit(
  //   [
  //     true,
  //     submitvalues.personArticleReviewTitle_Te ? submitvalues.personArticleReviewTitle_Te : '',
  //   ],
  //   input,
  //   'personArticleReviewTitle_Te',
  // )

  console.log(input, submitvalues, submitvalues.valueChanged, 'input')
  // updatePerson(input, submitvalues.valueChanged)
  const data = { input, submitvalues }
  // useEffect(() => {
  return createMultiplePersonsorNot(data, sendInputCreatePerson, sendInputObject)
  // }, [data])
  // sendInputObject(input)
  // return <div>SubmitCreatePerson</div>;
}

const createMultiplePersonsorNot = (data, sendInputCreatePerson, sendInputObject) => {
  console.log('inside create')
  // check if personIndex is present in submitvalues
  if (
    data.submitvalues.MultiplePersons &&
    data.submitvalues.personIndexSelectionObj[data.submitvalues.personIndex] === true
  ) {
    // if (data.submitvalues.personIndex) {

    if (data.submitvalues.getInputDataFromCreatePerson.length === 0) {
      const getInputDataFromCreatePersonTemp = data.input
      data.input.personIndex = data.submitvalues.personIndex
      data.input.personSelected =
        data.submitvalues.personIndexSelectionObj[data.submitvalues.personIndex]
      sendInputObject(data.input)
      sendInputCreatePerson(getInputDataFromCreatePersonTemp)
      return 'multiplePersons'
    }

    if (data.submitvalues.getInputDataFromCreatePerson.length === 1) {
      const getInputDataFromCreatePersonTemp = data.input
      data.input.personIndex = data.submitvalues.personIndex
      data.input.personSelected =
        data.submitvalues.personIndexSelectionObj[data.submitvalues.personIndex]
      sendInputObject(data.input)
      sendInputCreatePerson(getInputDataFromCreatePersonTemp)
      return 'multiplePersons'
    }
  } else if (
    data.submitvalues.MultiplePersons &&
    data.submitvalues.personIndexSelectionObj[data.submitvalues.personIndex] === false
  ) {
    return 'multiplePersons'
  } else {
    return createPerson(data.input, data.submitvalues.valueChanged)
  }
}

const createPerson = async (input, trueValue) => {
  if (Object.values(trueValue).some(e => e === true)) {
    try {
      // console.log(input, 'before updateinput')
      const createlog = await CreatePersonService(input)
      // console.log(createlog)
      if (createlog.statusCode === 'A005') {
        return createlog
      }
    } catch (error) {
      console.warn(error)
    }
  }
}

// const GalleryVideos = (inputData, input) => {
//   if (inputData.GalleryVideos && inputData.GalleryVideos.length > -1) {
//     const galleryVideos = inputData.GalleryVideos.map(e => ({
//       path: e.path.replace(AwsConfig.movieCdnUrl, ''),
//       title: e.title,
//       thumbnail: e.thumbnail ? e.thumbnail : '',
//       videoPlatform: e.videoPlatform,
//       // galleryTags: e.galleryTags ? e.galleryTags : [],
//       ...(e.galleryTags && e.galleryTags.length > 0 && { galleryTags: e.galleryTags }),
//     }))
//     input.galleryVideos = galleryVideos
//   }
// }

// const GalleryImages = (inputData, input) => {
//   if (inputData.GalleryImages && inputData.GalleryImages.length > -1) {
//     const galleryImages = inputData.GalleryImages.map(e => ({
//       path: e.path.replace(AwsConfig.movieCdnUrl, ''),
//       title: e.title,
//       // galleryTags: e.galleryTags,
//       ...(e.galleryTags && e.galleryTags.length > 0 && { galleryTags: e.galleryTags }),
//     }))
//     input.galleryImages = galleryImages
//     // truevalueedit([true, inputData.GalleryImages], input, 'galleryImages')
//   }
// }
